export default __webpack_public_path__ + "static/feature-2-35585b1e16c0a6c791efec2b0a589fce.png";